import { IPropertyFilter } from './IPropertyFilter'

export type Nullable = 'null' | 'notnull' | 'empty'

export interface INullableFilter<T> extends IPropertyFilter<T> {
  type: 'nullable'
  value: Nullable
}

export const isNullableFilter = <T>(
  filter: IPropertyFilter<T>,
): filter is INullableFilter<T> => filter.type === 'nullable'

export const normalizeNullableFilter = <T>({
  propertyName,
  value,
}: INullableFilter<T>): string =>
  value === 'empty'
    ? ''
    : `(${String(propertyName)} ${value === 'null' ? 'eq' : 'ne'} null)`
